import React, { forwardRef, useRef, useState } from 'react';
import {
  IconButton,
  Dialog,
  Typography,
  Slide,
  Box,
  Link,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function ErrorDialog({ onClose, errorCode, error }) {
  const [showDetails, setShowDetails] = useState(false);
  const timestamp = useRef(new Date().toISOString());
  const path = useRef(window.location.pathname);
  const Transition = forwardRef((props, ref) => (
    <Slide direction="up" ref={ref} {...props} />
  ));

  return (
    <Dialog
      fullScreen
      open={true}
      TransitionComponent={Transition}
      sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{ position: 'absolute', right: 8, top: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Box sx={{ maxWidth: 800, px: 3, position: 'relative' }}>
          <Typography
            variant="h5"
            sx={{ fontSize: { xs: '1.1rem', sm: '1.5rem' }, textAlign: 'left' }}
          >
            {`We're sorry, but we encountered an unexpected error. Please try refreshing the page. If the problem continues, contact support and reference error code `}
            <Box
              component="span"
              sx={{
                fontFamily: 'monospace',
                display: 'inline-block',
                fontWeight: 'bold',
              }}
            >
              {errorCode}
            </Box>
          </Typography>
          <Link
            component="button"
            onClick={() => error && setShowDetails(!showDetails)}
            underline="none"
            sx={{
              mt: 1,
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              color: 'text.secondary',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              cursor: error ? 'pointer' : 'default',
            }}
          >
            {timestamp.current} &middot; {path.current}
          </Link>
          {showDetails && error && (
            <Typography
              sx={{
                mt: 1,
                fontFamily: 'monospace',
                fontSize: '0.75rem',
                color: 'text.secondary',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                position: 'absolute',
                left: 0,
                right: 0,
                maxHeight: '30vh',
                overflow: 'auto',
                px: 3,
              }}
            >
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  );
}
